import React, { useState, Component } from 'react';
import {Link} from 'react-router-dom';


function ExternalMedia ({
    title,
    iframeSrc,
    placeholder
}) {

    const [accepted, setAccepted] = useState(false);

    if (accepted) {

        
        return (
             
                    <div className="externalMediaFrame">
                       
                        <iframe
                            src={iframeSrc}
                            title={title}
                            loading="lazy"
                            allowFullScreen
                        />
                </div>
               
        );
    }

    return (
             
                    <div className="external-media">
                      
                        <p> <h3 style={{color: 'white'}}>Tutorial: {title}</h3><br/>
                            Dieser Inhalt wird aus einer externen Quelle (Youtube) eingebunden. <br/>
                            Mit dem Klicken auf "externe Inhalte laden" stimmen Sie den Nutzungsbedingungen und der Datenschutzerklärung des entprechenden Anbieters zu.

                           
                        </p>

                        <button onClick={() => setAccepted(true)}>
                            externe Inhalte laden
                        </button>
                    </div>
              
                 
            );
}

export default ExternalMedia;


